export default "__VITE_ASSET__BWNBpwKi__"